import { Check } from "lucide-react";

// 329: cesta objednávky v jedné řádce — Objednáno → Převzato (doklad) → Faktura → Zaplaceno.
// Nováčkovi hned řekne, co už je hotové a co ještě chybí.
function Step({ on, children, testid }) {
  return (
    <span data-testid={testid} data-on={on ? "1" : "0"}
      className={`inline-flex items-center gap-1.5 rounded-xl px-2.5 py-1.5 text-[12.5px] font-bold ${on ? "bg-success/10 text-success" : "border-[1.5px] border-dashed border-border bg-card text-muted-foreground"}`}>
      {on && <Check size={13} strokeWidth={3} aria-hidden="true" />}{children}
    </span>
  );
}

export function OrderChain({ ordered, received, note, invoice, paid, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="order-chain">
      <Step on={!!ordered} testid="chain-ordered">Objednáno{ordered ? ` ${ordered}` : ""}</Step>
      <Step on={!!received} testid="chain-received">{received ? `Převzato${note ? " · doklad" : ""}` : "Převzato —"}</Step>
      <Step on={!!invoice} testid="chain-invoice">{invoice ? `Faktura ${invoice}` : "Faktura —"}</Step>
      <Step on={!!paid} testid="chain-paid">{paid ? `Zaplaceno ${paid}` : "Zaplaceno —"}</Step>
    </div>
  );
}
